export default "/_next/static/fonts/0c39607942a8668164f74679c56e5c2f.ttf";